<div class="modal-body has-bg user-guide-modal text-center">
  <!-- Watch video -->
  @if (showVideo) {
    <div class="embed-responsive embed-responsive-16by9" [ngStyle]="{'background-color':info?.content.color}">
      <button type="button" class="btn-close btn-close-white" (click)="closeModel()" aria-label="close user guide"></button>
      @if (url) {
        <div>
          <iframe class="embed-responsive-item" [src]="url"
            allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Vault">
          </iframe>
        </div>
      }
      @if (!url) {
        <div>
          <label>This Video is under development and will be complete by December 15th</label>
        </div>
      }
    </div>
  }

  @if (!showVideo) {
    <!--Get Started Popup Static Screen-->
    @if (info?.name=='loginpopup') {
      <div class="login-popup-div">
        <div class="login-title" [ngStyle]="{'background-color': info?.content?.color}">
          <button type="button" class="btn-close" (click)="closeModel()" aria-label="close user guide"></button>
          <div class=" user-guide-top-login" >
            <div class="user-guide-title">
              <img  src="assets/images/familycentral-logo.svg" alt="FamilyCentral-Logo">
            </div>
            <h3 class="text-center mt-3" >Welcome To Family Central.</h3>
            <p class="text-center mt-2">This Area Will Have a Video That Will Help You Learn Of The Important Features of Your Application. We Will Teach You How To Create Your Own Secure Personal Family Office. The New Video Will Be Professionally Produced and Installed In The Site By December 1st, 2023.</p>
            <button type="button" class="primary_btn medium-blue mt-3" (click)="closeModel()">Get Started</button>
          </div>
        </div>
      </div>
    }
    <!--Tile Popups-->
    @if (info?.name!='loginpopup') {
      <div class="title" [ngStyle]="{'background-color': info?.content?.color}">
        <button type="button" class="btn-close btn-close-white" [ngStyle]="{'color':info?.name=='loginpopup'?'var(--secondaryBlack)':'#fff'}" (click)="closeModel()" aria-label="close user guide"></button>
        <div class="user-guide-top" >
          <div class="user-guide-title">
            <img  [ngClass]="info?.name=='loginpopup'?'':'filter-class' " src="assets/images/{{info?.content?.icon}}"  alt="{{info?.content?.header}} icon">
            <h4>{{info?.content?.header}}</h4>
          </div>
          <p class="text-start" [ngStyle]="{'color':info?.name=='loginpopup'?'var(--secondaryBlack)':'#fff'}">{{info?.content?.message}}</p>
        </div>
      </div>
    }
    <!-- Individual Features -->
    <div class="features-info">
      <!-- Looping item -->
      @for (childinfo of info?.content?.boxContent; track childinfo) {
        <div class="single-feature">
          <p><strong>{{childinfo.title}}</strong></p>
          <p [innerHTML]="childinfo?.content"></p>
        </div>
      }
    </div>
    @if (showGetstart&&info?.name!='loginpopup') {
      <div class="user-action-btn d-flex align-items-center justify-content-center">
        <button type="button" class="primary_btn medium-blue" (click)="closeModel()">Get Started</button>
        <button type="button" class="border_btn" (click)="showVideo=true">Watch Video</button>
      </div>
    }
    @if (showDontshowClick) {
      <div class="dont-show-again d-flex justify-content-center">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="dontShowAgain" name="dontShowAgain"
            [(ngModel)]="dontShowAgain">
            <label class="form-check-label" for="dontShowAgain">Don’t show me again.</label>
          </div>
        </div>
      }
    }
  </div>